var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataUrl)?_c('div',{staticClass:"qr-container",attrs:{"data-cy":"order-qr-code"}},[_c('div',{staticClass:"qr-frame"},[_c('img',{attrs:{"src":_vm.dataUrl,"alt":_vm.$t('screens.order.qrCodeTitle')}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }